(function roleRoleAssociateContainerTypesControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleAssociateContainerTypesController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend',
            'adminRoleService', 'adminContainerTypeService',
            function roleAssociateFunctionsController($scope, config, $state, $translate, $stateParams, errors,
                adminRoleService, adminContainerTypeService) {

                $scope.isContainerType = true;

                $scope.role = {
                    name: $stateParams.name
                };

                $scope.cancel = function () {
                    $state.go('role-find-preselect', { name: adminRoleService.getFilter().Name });
                };

                $scope.models = {
                    selected: null,
                    associated: {
                        "title": null,
                        "list": []
                    },
                    availables: {
                        "title": null,
                        "list": []
                    }
                };

                $translate(['RoleAssociateContainerTypesTitle', 'ContainerTypeAccociatedList', 'ContainerTypeAvailableList']).then(function (translated) {
                    $scope.title = translated.RoleAssociateContainerTypesTitle;
                    $scope.models.associated.title = translated.ContainerTypeAccociatedList;
                    $scope.models.availables.title = translated.ContainerTypeAvailableList;
                });

                $scope.moveItemFromAssociated = function (item, index) {
                    $scope.models.associated.list.splice(index, 1);
                    $scope.models.availables.list.push(item);
                }

                $scope.moveItemFromAvailables = function (item, index) {
                    $scope.models.availables.list.splice(index, 1);
                    $scope.models.associated.list.push(item);
                }

                adminContainerTypeService.getRoleContainerTypes($stateParams.id).then(function (containerTypes) {
                    $scope.models.associated.list = containerTypes;
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                }).then(function () {
                    adminContainerTypeService.getNotInRole($stateParams.id).then(function (result) {
                        $scope.models.availables.list = result;
                    });
                });

                $scope.save = function () {
                    var resultList = [];
                    $scope.models.associated.list.forEach(function (dt) {
                        if (dt.roles && dt.roles.metadatas && dt.roles.metadatas.length > 0) {
                            dt.metadatas = dt.roles.metadatas;
                        }

                        if (dt.metadatas && dt.metadatas.metadatas && dt.metadatas.metadatas.length > 0) {
                            dt.metadatas = dt.metadatas.metadatas;
                        }
                    });

                    return adminContainerTypeService.setRoleContainerTypes($stateParams.id, $scope.models.associated.list).then(function () {
                        $state.go('role-find-preselect', { name: adminRoleService.getFilter().Name });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };
            }
        ]);
})();